import {
  ApiParams,
  BaseClient,
  IActionResponse,
  IActionResult,
  IPagedResult,
} from "../../../assets/utils/lib";
import { CommunityCategoryDto, LookupDto, SearchDto } from "../../dto";

export class CommunityCategoryClient extends BaseClient {
  routes = ["CommunityResource", "CommunityCategory"];

  async getCategoryAsync(
    id: string | undefined
  ): Promise<CommunityCategoryDto> {
    const actions: string[] = ["GetCategory"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];

    const result: CommunityCategoryDto =
      await this.getAsync<CommunityCategoryDto>(actions, params);
    return result;
  }

  async searchCommunityCategoriesAsync(
    payload: SearchDto | undefined
  ): Promise<IPagedResult<CommunityCategoryDto>> {
    const actions: string[] = ["SearchCategories"];
    const result: IPagedResult<CommunityCategoryDto> = await this.postAsync<
      SearchDto,
      CommunityCategoryDto,
      IPagedResult<CommunityCategoryDto>
    >(actions, payload);
    return result;
  }

  async saveCommunityCategoryAsync(
    payload: CommunityCategoryDto | undefined
  ): Promise<IActionResult<CommunityCategoryDto>> {
    const actions: string[] = ["SaveCategory"];
    return await this.postAsync<CommunityCategoryDto>(actions, payload);
  }

  async deActivateCommunityCategoryAsync(
    id: string | undefined
  ): Promise<IActionResponse> {
    const actions: string[] = ["DeActivateCategory"];
    const params: ApiParams[] = [new ApiParams("categoryId", id, true)];

    return await this.getAsync(actions, params);
  }

  async deleteCategoryAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteCategory"];
    const params: ApiParams[] = [
      new ApiParams("id", id, true),
      new ApiParams("hardDelete", false),
    ];
    return await this.deleteAsync(actions, params);
  }

  async getLookupsAsync(): Promise<{
    community: LookupDto[];
  }> {
    const actions: string[] = ["GetLookups"];
    const result: {
      community: LookupDto[];
    } = await this.getAsync<{
      community: LookupDto[];
    }>(actions, []);
    return result;
  }

  async getCommunityCategoryAsync(
    communityId: string
  ): Promise<CommunityCategoryDto> {
    const actions: string[] = ["GetCommunityCategory"];
    const params: ApiParams[] = [
      new ApiParams("communityId", communityId, true),
    ];

    const result: CommunityCategoryDto =
      await this.getAsync<CommunityCategoryDto>(actions, params);
    return result;
  }
}
